import { render } from "./ControlPanelPhone.vue?vue&type=template&id=22c19066&scoped=true"
import script from "./ControlPanelPhone.vue?vue&type=script&lang=js"
export * from "./ControlPanelPhone.vue?vue&type=script&lang=js"

import "./ControlPanelPhone.vue?vue&type=style&index=0&id=22c19066&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c19066"]])

export default __exports__